import React from 'react';
import { RiDownload2Fill } from "react-icons/ri";

const ExportPDFButton = () => {
  const handleExport = () => {
    // Add a title and timestamp before printing
    const originalTitle = document.title;
    const timestamp = new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
    
    document.title = `Spirit Cargo Analytics Report - ${timestamp}`;
    
    // Trigger print
    window.print();
    
    // Restore original title
    document.title = originalTitle;
  };

  return (
    <button
      onClick={handleExport}
      className="export-pdf-button export-btn"
      style={{
        backgroundColor: 'white',
        color: '#000099',
        border: '2px solid',
        borderColor: '#F2BA91',
        padding: '8px 32px',
        fontSize: '14px',
        fontWeight: '800',
        borderRadius: '40px',
        cursor: 'pointer',
        letterSpacing: '0.5px',
        whiteSpace: 'nowrap',
      }}
    >
      EXPORT PDF <span className='download-icon' style={{
        verticalAlign: 'middle',
        marginLeft: '2px',
        fontSize: '1rem',
        display: 'inline-flex',
        alignItems: 'center',
        marginBottom: '4px',
        color: '#000099'
      }}><RiDownload2Fill/></span>
    </button>
  );
};

export default ExportPDFButton;
